import React from 'react';
import {Icon} from 'shared/helpers';
import styled from 'styled-components';

interface FloatingButtonProps {
    icon: string;
    className?: string;
    onClick?: () => void;
    title?: string;
    disabled?: boolean;
    color?: string;
}

export const FloatingButton = ({
    icon,
    className,
    onClick,
    title,
    disabled,
    color,
}: FloatingButtonProps) => {
    return (
        <Button
            className={className}
            onClick={onClick}
            title={title}
            disabled={disabled}>
            <Icon iconName={icon} color={color} />
        </Button>
    );
};

const Button = styled.button`
    background: white;
    border-radius: 8px;
    box-shadow: 0px 1px 9px 3px #bfbfbf;
    border: 0;
    padding: 6px 9px;
    margin: 5px 0;
    cursor: pointer;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }

    > img {
        width: 24px;
        height: 24px;
    }

    &:active:not(:disabled) {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
